"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateLoyaltyDetails = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@heroui/react");
var loyalty_1 = require("../../../../../reducers/slices/loyalty/loyalty");
var react_redux_1 = require("react-redux");
var react_2 = require("react");
var branch_dropdown_1 = require("../../../../../components/form/branch-dropdown");
var react_3 = require("@iconify/react");
var constants_1 = require("../../../../../constants/constants");
var constants_2 = require("../constants");
var constants_3 = require("../../billing/loyalty/constants");
var main_1 = require("../../../../../reducers/slices/main");
var loyalty_2 = require("../../../../../api/loyalty");
var validateForm_1 = require("../../../../../helpers/validateForm/validateForm");
var CreateLoyaltyDetails = function (_a) {
    var _b, _c;
    var customerId = _a.customerId;
    var dispatch = (0, react_redux_1.useDispatch)();
    var selectedLoyalty = (0, react_redux_1.useSelector)(function (state) { return state.loyaltyState; }).selectedLoyalty;
    var _d = (0, react_2.useState)(false), isInteracted = _d[0], setIsInteracted = _d[1];
    var customer = (0, react_redux_1.useSelector)(function (state) { return state.customerState; }).customer;
    var _e = (0, react_2.useState)(""), selectedBranchId = _e[0], setSelectedBranchId = _e[1];
    var createCustomerLoyalty = (0, loyalty_2.useCreateCustomerLoyaltyMutation)()[0];
    var _f = (0, validateForm_1.validateForm)(selectedLoyalty, { enabled: isInteracted }), errors = _f.errors, isValid = _f.isValid;
    var _g = (0, validateForm_1.validateForm)(selectedLoyalty.card, {
        enabled: isInteracted,
        validationConfig: constants_2.cardValidationConfig,
    }), cardErrors = _g.errors, cardIsValid = _g.isValid;
    (0, react_2.useEffect)(function () {
        dispatch((0, loyalty_1.setSelectedLoyalty)(constants_3.initialLoyaltyValues));
    }, []);
    var _setLoyalty = function (value) {
        dispatch((0, loyalty_1.setSelectedLoyalty)(__assign(__assign({}, selectedLoyalty), value)));
        if (!isInteracted) {
            setIsInteracted(true);
        }
    };
    var showLoader = function () {
        dispatch((0, main_1.setContentModal)({
            title: "Please Wait...",
            content: (0, jsx_runtime_1.jsx)(react_1.Spinner, { size: "sm" }),
        }));
    };
    var _createLoyalty = function () { return __awaiter(void 0, void 0, void 0, function () {
        var card, payload, error_1, message;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    showLoader();
                    card = selectedLoyalty.card, payload = __rest(selectedLoyalty, ["card"]);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    // invalidatesTags refetches this customer's loyalty, so there is no follow-up fetch to dispatch here
                    return [4 /*yield*/, createCustomerLoyalty({
                            customerId: customerId,
                            body: __assign(__assign({}, payload), { cell_number: customer.cell_number, member_card_number: selectedLoyalty.card.number, linked: selectedLoyalty.card.linked, member_branch_id: selectedBranchId }),
                        }).unwrap()];
                case 2:
                    // invalidatesTags refetches this customer's loyalty, so there is no follow-up fetch to dispatch here
                    _b.sent();
                    dispatch((0, main_1.setContentModal)(null));
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _b.sent();
                    message = (_a = error_1 === null || error_1 === void 0 ? void 0 : error_1.error) !== null && _a !== void 0 ? _a : "The loyalty sign up was unsuccessful.";
                    dispatch((0, main_1.setContentModal)({ title: constants_1.REQUEST_ERROR_TITLE, content: (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: message }) }));
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return ((0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col", children: [(0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col gap-4", children: [(0, jsx_runtime_1.jsx)("div", { className: "flex flex-col", children: (0, jsx_runtime_1.jsxs)(react_1.TextField, { value: selectedLoyalty === null || selectedLoyalty === void 0 ? void 0 : selectedLoyalty.loyalty_number, onChange: function (value) {
                                _setLoyalty({ loyalty_number: value });
                            }, isInvalid: !!errors.loyalty_number, children: [(0, jsx_runtime_1.jsx)(react_1.Label, { children: "Loyalty number" }), (0, jsx_runtime_1.jsx)(react_1.Input, {}), errors.loyalty_number ? (0, jsx_runtime_1.jsx)(react_1.FieldError, { children: errors.loyalty_number }) : null] }) }), (0, jsx_runtime_1.jsx)("div", { className: "flex flex-col", children: (0, jsx_runtime_1.jsxs)(react_1.TextField, { value: (_b = selectedLoyalty === null || selectedLoyalty === void 0 ? void 0 : selectedLoyalty.card) === null || _b === void 0 ? void 0 : _b.number, onChange: function (value) {
                                var linked = (selectedLoyalty === null || selectedLoyalty === void 0 ? void 0 : selectedLoyalty.card).linked;
                                _setLoyalty({ card: { number: value, linked: linked } });
                            }, isInvalid: !!(cardErrors === null || cardErrors === void 0 ? void 0 : cardErrors.number), children: [(0, jsx_runtime_1.jsx)(react_1.Label, { children: "Loyalty card number" }), (0, jsx_runtime_1.jsx)(react_1.Input, {}), (cardErrors === null || cardErrors === void 0 ? void 0 : cardErrors.number) ? (0, jsx_runtime_1.jsx)(react_1.FieldError, { children: cardErrors.number }) : null] }) }), (0, jsx_runtime_1.jsx)(branch_dropdown_1.BranchDropdown, { label: "Select a branch...", selectedIds: selectedBranchId ? [selectedBranchId] : [], onSelectionChange: function (ids) {
                            var _a;
                            setSelectedBranchId((_a = ids[0]) !== null && _a !== void 0 ? _a : "");
                            _setLoyalty({ member_branch_id: ids[0] });
                        } }), (0, jsx_runtime_1.jsx)("div", { className: "flex flex-col", children: (0, jsx_runtime_1.jsxs)(react_1.Checkbox, { isSelected: (_c = selectedLoyalty === null || selectedLoyalty === void 0 ? void 0 : selectedLoyalty.card) === null || _c === void 0 ? void 0 : _c.linked, isRequired: true, onChange: function (isSelected) {
                                var number = (selectedLoyalty === null || selectedLoyalty === void 0 ? void 0 : selectedLoyalty.card).number;
                                _setLoyalty({ card: { linked: isSelected, number: number } });
                            }, children: [(0, jsx_runtime_1.jsx)(react_1.Checkbox.Control, { children: (0, jsx_runtime_1.jsx)(react_1.Checkbox.Indicator, {}) }), (0, jsx_runtime_1.jsx)(react_1.Checkbox.Content, { children: (0, jsx_runtime_1.jsx)(react_1.Label, { children: "Link to Physical Card" }) })] }) })] }), (0, jsx_runtime_1.jsxs)("div", { className: "flex pt-4 gap-4", children: [(0, jsx_runtime_1.jsx)(react_1.Button, { variant: "secondary", size: "sm", onPress: function () { return dispatch((0, main_1.setContentModal)(null)); }, children: "Cancel" }), (0, jsx_runtime_1.jsxs)(react_1.Button, { isDisabled: !isValid || !cardIsValid, size: "sm", variant: "primary", onPress: _createLoyalty, children: [(0, jsx_runtime_1.jsx)(react_3.Icon, { icon: "mdi:content-save" }), "Save"] })] })] }));
};
exports.CreateLoyaltyDetails = CreateLoyaltyDetails;
